import moment from 'moment-timezone';
import { environment } from 'environments';
class PatientNotes {
  constructor($log, $scope, Orders, Users, Notifications, toastr, Auth) {
    'ngInject';
    angular.extend(this, {
      $log,
      $scope,
      Notifications,
      toastr,
      Orders,
      Users,
      currentUser: Auth.profile,
      titles: [
        'Rejected Reason:',
        'Rejected By:',
        'Not Treated Reason:',
        'Evaluating Clinician:',
        'Visit',
        'Patient Support Team:',
      ],
      pagination: {
        limit: 10,
      },
      notes: [],
      dataString: {
        visit: this.visit,
        patient: this.patient,
      },
    }); // When to reload notes

    $scope.$on('visit:updated', () => this.loadNewer());
    $scope.$on('visit:denied', () => this.loadNewer());
    $scope.$on('visit:load', () => this.loadNewer());
    $scope.$on('visit:completed', () => this.loadNewer());
    $scope.$on('visit-notes:refresh', () => this.loadNewer());
    $scope.$on('create-visit-note', (event, note = '') => {
      if (note) this.post(note);
    });
  }

  $onInit() {
    this.dataString = {
      visit: this.visit,
      patient: this.patient,
    };
    this.loadOlder();
  }

  formatDate(iso_date) {
    if (!iso_date) return null;
    const formatted_date = moment.tz(iso_date, this.timezone).format('DD/MMM/YY h:mm A');
    return formatted_date;
  }
  /**
   * Determines if older notes exist
   */

  hasMoreNotes() {
    return this.pagination.total > this.notes.length;
  }
  /**
   * Loads newer notes
   */

  loadNewer() {
    const newerPagination = {};

    if (this.pagination.cursors) {
      const { after } = this.pagination.cursors;
      newerPagination.after = after;
    }

    this.getNotes(newerPagination).then(({ notes, pagination }) => {
      Object.assign(this.pagination, {
        after: pagination.cursors && pagination.cursors.after,
        total: pagination.total,
      });
      if (notes.length) {
        const noteIds = new Set(notes.map(n => n.id));
        this.notes = [...notes, ...this.notes.filter(n => !noteIds.has(n.id))];
      }
    });
  }
  /**
   * Loads previous notes
   */

  loadOlder() {
    const olderPagination = {}; //console.log(this.pagination);

    if (this.pagination.cursors) {
      const { before } = this.pagination.cursors;
      olderPagination.before = before;
    }

    this.getNotes(olderPagination).then(({ notes, pagination }) => {
      Object.assign(this.pagination, {
        before: pagination.cursors && pagination.cursors.before,
        total: pagination.total,
      });
      this.notes.push(...notes);
    });
  }
  /**
   * Loads, formats and passes on notes on to next thennable statement
   * Will not append notes to view
   */

  getNotes(query) {
    this.loading = true;
    return this.Users.getNotes(this.patient.id, query)
      .then(({ data }) => {
        let { data: notes, pagination } = data;
        Object.assign(this.pagination, pagination);
        notes = this.formatNotes(notes);
        return {
          notes,
          pagination,
        };
      })
      .catch(err => this.$log.log(err))
      .finally(() => {
        this.loading = false;
      });
  }

  post(note) {
    this.posting = true;
    this.Orders.postNote(note)
      .then(() => {
        this.note = '';
        this.showForm = false;
        this.loadNewer();
      })
      .catch(err => {
        if (err.status === 403) {
          this.toastr.error(this.Notifications.orders.locked);
        }
      })
      .finally(() => {
        this.posting = false;
      });
  }
  /**
   * Boldens rejection notes without having to format from backend
   */

  formatNotes(notes) {
    notes.forEach(note => {
      this.titles.forEach(title => {
        const startPos = note.text.indexOf(title);

        if (startPos > -1) {
          const template = `${startPos > 0 ? '<span class="block"></span>' : ''}<strong>${title}</strong>`;
          note.text = note.text.replace(/,/gi, '').splice(startPos, title.length, template);
        }
      });
    });
    return notes;
  }
}

PatientNotes.$inject = ['$log', '$scope', 'Orders', 'Users', 'Notifications', 'toastr', 'Auth'];
angular.module('pims').component('patientNotes', {
  templateUrl: 'app/components/patient-notes/patient-notes.html',
  controller: PatientNotes,
  bindings: {
    visit: '<',
    patient: '<',
    timezone: '=',
  },
});
